import React, { useContext, useState } from 'react';
import './WelcomeScreen.css';
import { MasterContext } from '../../../ContextApi/context';
import ConnUrls from '../../../Connections/ConnectURL';
import { Close } from '@mui/icons-material';
import myFunctions from '../../../myFunctions';

/**
 * WelcomeScreen
 *
 * Entry modal offering "registered user" / "new user" login paths.
 *
 * Props:
 * @param {boolean} isOpen        - controls visibility of the modal
 * @param {string} icon           - icon name (ti-* class suffix), default "ice-cream-2"
 * @param {string} title          - heading text, default "ברוכים הבאים"
 * @param {string} description    - body text under the heading
 * @param {string} headerLabel    - label next to the top-right back button, default "התחברות"
 * @param {string} newUserLabel   - secondary button text, default "משתמש חדש"
 * @param {function} onBack       - called when the top-right circular button is clicked
 * @param {function} onSendCode   - async (phone) => { errMsg, notRegistered } | undefined. sends the SMS code
 * @param {function} onNewUser    - (phone?) called to open registration
isOpen = true,
        icon = 'ice-cream-2',
        title = 'ברוכים הבאים',
        description = 'לאפליקציה המקומית אשדוד בתפריט. אנחנו דואגים שכל מנה תהיה הכי משתלמת בסביבה.',
        headerLabel = 'התחברות',
        newUserLabel = 'משתמש חדש',
        onBack,
        onSendCode,
        onNewUser,
*/
const WelcomeScreen = (props) => {

    const [master, setMaster] = useContext(MasterContext);

    myFunctions.useEscapeKey(props.isOpen ? props.onBack : null);
    // Back סוגר רק כשההתחברות פתוחה כחלון (לא בעמוד /LoginPage)
    myFunctions.useBackClose(props.isOpen ? props.backClose : null);

    const [phone, setPhone] = useState("");
    const [erMsg, setErMsg] = useState("");
    const [notRegistered, setNotRegistered] = useState(false);
    const [sending, setSending] = useState(false);

    const kbOpen = myFunctions.useKeyboardOpen();

    if (!props.isOpen) return null;

    const sendCode = async () => {
        if (sending) return;
        if (!/^0\d{8,9}$/.test(phone)) {
            setErMsg("יש להזין מספר טלפון תקין");
            return;
        }
        setErMsg("");
        setNotRegistered(false);
        setSending(true);
        const res = await props.onSendCode(phone);
        setSending(false);
        if (res && res.errMsg) {
            setErMsg(res.errMsg);
            setNotRegistered(!!res.notRegistered);
        }
    }

    return (
        <div className="ws-backdrop" dir="rtl">
            <div className={`ws-card${kbOpen ? " ws-kb" : ""}`}>
                <div className="ws-header" dir="rtl">
                    <button type="button"
                        className="btnReset ws-Close-btn onRight"
                        onClick={props.onBack}
                        aria-label="חזור">
                        <Close aria-hidden="true" style={{ width: '100%', height: '100%' }} />
                    </button>
                    <span className="arrowing fullRow ws-header-label">{props.headerLabel}</span>

                    {/* <button
                        type="button"
                        className="ws-header-btn"
                        onClick={props.onBack}
                        aria-label="חזור"
                    >
                        <i className="ti ti-arrow-left" aria-hidden="true"></i>
                    </button> */}

                </div>

                {/* <div className="ws-icon-wrap"> */}
                    <div className="roundWrap">
                        <img src={`${ConnUrls.media(master.welcomeImg)}`} alt="Welcome" className="ws-logo" />
                        {/* <i className={`ti ti-${props.icon} ws-icon`} aria-hidden="true"></i> */}
                    </div>
                {/* </div> */}

                <div className={"bold ws-title arrowing"}>{props.txt1 ? props.txt1 : "ברוכים הבאים"}</div>
                <div className={"ws-desc ws-promo arrowing"}>{props.txt2 ? props.txt2 : "האפליקציה המקומית של אשדוד, עם המנות הכי משתלמות בסביבה."}</div>

                <label className="ws-label" htmlFor="wsPhone">הזינו מספר נייד ונשלח לכם קוד ב-SMS</label>
                <input
                    id="wsPhone"
                    className={`ws-input${erMsg ? " ws-input-err" : ""}`}
                    placeholder="05X-XXXXXXX"
                    value={phone}
                    onChange={(e) => {
                        let num = e.target.value.replace(/\D/g, '');
                        if (num.startsWith('972')) num = '0' + num.slice(3);
                        setPhone(num.slice(0, 10));
                        setErMsg("");
                        setNotRegistered(false);
                    }}
                    onKeyUp={(e) => { if (e.key === 'Enter') sendCode(); }}
                    onFocus={myFunctions.scrollFieldIntoView}
                    type="tel"
                    inputMode="numeric"
                    autoComplete="tel"
                    dir="ltr"
                    aria-invalid={!!erMsg}
                    aria-describedby="wsPhoneErr"
                />
                <div id="wsPhoneErr" className="ws-err" role="alert">
                    {notRegistered ? "המספר הזה עדיין לא רשום אצלנו" : erMsg}
                </div>

                {notRegistered ?
                    <button type="button" className="ws-btn ws-btn-primary" onClick={() => props.onNewUser(phone)}>
                        להרשמה עם המספר הזה
                    </button>
                    :
                    <button type="button" className="ws-btn ws-btn-primary" onClick={sendCode} disabled={sending}>
                        {sending ? "שולחים..." : "שלחו לי קוד"}
                    </button>
                }

                <div className="ws-newUser">
                    עדיין לא רשומים?{" "}
                    <button type="button" className="btnReset ws-link" onClick={() => props.onNewUser()}>
                        {props.newUserLabel || "להרשמה"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WelcomeScreen;